require('./header');
require('./slider');
